import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const CONSTANT_API_REDUCER_KEY = "constantApi";

export const constantApi = createApi({
  reducerPath: CONSTANT_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["constant"],
  endpoints: (builder) => ({
    getConstants: builder.query({
      query: ({ key }) => {
        return key
          ? {
              url: `admin/users/app-metadata/?key=${key}`,
            }
          : {
              url: `admin/users/app-metadata/`,
            };
      },
      providesTags: ["constant"],
    }),

    getConstant: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `admin/users/app-metadata/${id}`,
        };
      },
      providesTags: ["constant"],
    }),
    getLogo: builder.query({
      query: () => {
        return {
          url: `/users/app-metadata/logo/`,
        };
      },
      providesTags: ["constant"],
    }),

    createConstant: builder.mutation({
      query: (body) => {
        return {
          url: "admin/users/app-metadata/",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["constant"],
    }),

    updateConstant: builder.mutation({
      query: ({ id, body }) => ({
        url: `admin/users/app-metadata/${id}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["constant"],
    }),

    deleteConstant: builder.mutation({
      query: (id) => ({
        url: `admin/users/app-metadata/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["constant"],
    }),
    uploadLogo: builder.mutation({
      query: (body) => ({
        url: `admin/users/app-metadata/logo/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["constant"],
    }),
  }),
});

export const {
  useGetConstantsQuery,
  useCreateConstantMutation,
  useDeleteConstantMutation,
  useUpdateConstantMutation,
  useGetConstantQuery,
  useUploadLogoMutation,
  useGetLogoQuery,
} = constantApi;
